import React from 'react';
import { connect } from "react-redux";
import Modal from './Modal/Modal';

const modals = props => {
	let modalBodyText = '';
	let hideCancelButton = true;
	let confirmationText = 'OK';

	if (props.type === 'tutorialNotification') {
		modalBodyText = 'Need help? You can access tutorial from the menu (top-left of this app).';
	}

	if (props.type === 'attentionModal') {
		modalBodyText = 'Please select 1 Intro block, 3 Body blocks and 1 Outro block before playing.'
	}

	if (props.type === 'firstWalkthroughModal') {
		if (props.currentApp === 'app-1') {
			modalBodyText = 'Hi, welcome to EZ-Talk, a very intuitive and friendly tool to help you with the Talk in Part 3 of Oral Proficiency Test.'
		}
		if (props.currentApp === 'app-2') {
			modalBodyText = 'Hello, welcome to EZ-C, a very intuitive and user-friendly tool to help you answer opinion questions on the Oral Proficiency Test in an abstract and general way.'
		}
		if (props.currentApp === 'app-3') {
			modalBodyText = 'This application is the perfect tool to pass the test of reading comprehension.'
		}
		confirmationText = 'Next';
	}

	if (props.type === 'deleteOneSequenceModal') {
		modalBodyText = 'Saving this sequence will cause the first saved sequence to be deleted. Continue?';
		confirmationText = 'Yes';
		hideCancelButton = false;
	}

	if (props.type === 'appCloseModal') {
		modalBodyText = 'Are you sure you want to close the app?';
		confirmationText = 'Yes';
		hideCancelButton = false;
	}

	if (props.type === 'saveSequenceModal') {
		modalBodyText = 'Would you like to save this sequence?';
		confirmationText = 'Yes';
		hideCancelButton = false;
	}

	return (
		<Modal
			showModal={!!props.type}
			hideModal={() => props.modalsHandler()}
			hideCancelButton={hideCancelButton}
			modalBodyText={modalBodyText}
			confirmationText={confirmationText}
			confirmed={() => props.modalsHandler(true)}
		/>
	)
};

const mapStateToProps = state => ({ currentApp: state.appReducer.currentApp });
export default connect(mapStateToProps)(modals);